<span [ngClass]="computedClass"
  [ngbTooltip]="tooltipText"
  [placement]="tooltipPlacement"
  class="align-center">
  @if (icon) {
    <sb-icon
      [name]="icon.name"
      [altText]="icon.tooltip"
      [size]="icon.size"
      class="mr-2"
    [ngClass]="icon.class"></sb-icon>
  }
  @if (isCurrency) {
    <span
    [innerHTML]="currencySymbol"></span>
  }
  @if (message) {
    <span
    [innerHTML]="message | translate"></span>
  }
  <ng-content></ng-content>
</span>
